import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type FileSearchResultFragment = { id: string, name: string, category: Types.FileCategoryEnum, projectStatus?: Types.FileProjectStatusEnum | null, systemGenerated?: boolean | null, childrenIds?: Array<string> | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null };


export type FileSearchResultFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const FileSearchResultFragmentDoc = /*#__PURE__*/ gql`
    fragment FileSearchResult on FileSchema {
  id
  iconSettings {
    type
    value
  }
  name
  category
  projectStatus
  systemGenerated
  childrenIds
}
    `;